import { render } from "./articleRight.vue?vue&type=template&id=4da8face&scoped=true"
import script from "./articleRight.vue?vue&type=script&lang=js"
export * from "./articleRight.vue?vue&type=script&lang=js"

import "./articleRight.vue?vue&type=style&index=0&id=4da8face&lang=scss&scoped=true"

import exportComponent from "D:\\QYYY\\mall_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4da8face"]])

export default __exports__